/* dashboard-rediseno (15-oct-2026): LOS MENUS Y PANELES FLOTANTES DEL PANEL, UNO A LA VEZ.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   4.5 del encargo: los paneles flotantes y los menus (tres puntos, informacion, figuras, motivo
   de falla) se cierran al tocar fuera, al tocar otra vez su boton y con Esc; hay uno abierto a
   la vez; y al cerrar con el teclado el foco vuelve al boton que los abrio.

   `abrirUnico(cerrar)` cierra el que estuviera abierto y anota este; `soltarUnico(cerrar)` lo
   borra si sigue siendo el anotado. Es una variable de modulo a proposito: un solo Panel vive a
   la vez y los flotantes no viajan entre pantallas. */
import { useEffect } from 'react';

let cerrarElAbierto = null;

export function abrirUnico(cerrar) {
  if (cerrarElAbierto && cerrarElAbierto !== cerrar) {
    const anterior = cerrarElAbierto;
    cerrarElAbierto = null;
    anterior();
  }
  cerrarElAbierto = cerrar;
}

export function soltarUnico(cerrar) {
  if (cerrarElAbierto === cerrar) cerrarElAbierto = null;
}

/* Mientras `abierto`: registra el cierre (uno a la vez), escucha el toque de fuera de `cajaRef`
   y de `botonRef` (mousedown y touchstart, como el panel de creditos de hoy) y Esc, que cierra y
   devuelve el foco al boton. `cerrar` tiene que ser estable (un useCallback). */
export function useCierreDeFlotante(abierto, cerrar, cajaRef, botonRef) {
  useEffect(() => {
    if (!abierto) return undefined;
    abrirUnico(cerrar);
    const fuera = (e) => {
      const caja = cajaRef && cajaRef.current;
      const boton = botonRef && botonRef.current;
      if (caja && caja.contains(e.target)) return;
      if (boton && boton.contains(e.target)) return;
      cerrar();
    };
    const tecla = (e) => {
      if (e.key !== 'Escape') return;
      cerrar();
      const boton = botonRef && botonRef.current;
      if (boton && typeof boton.focus === 'function') boton.focus();
    };
    document.addEventListener('mousedown', fuera);
    document.addEventListener('touchstart', fuera);
    document.addEventListener('keydown', tecla);
    return () => {
      soltarUnico(cerrar);
      document.removeEventListener('mousedown', fuera);
      document.removeEventListener('touchstart', fuera);
      document.removeEventListener('keydown', tecla);
    };
  }, [abierto, cerrar, cajaRef, botonRef]);
}
